<kendo-dialog title="Phone Dialer" class="kendo-modal modal-1180" *ngIf="showPhoneDialerClose"
  (close)="closePhoneDialerPopup()">
  <div class="common-popup-space">
    <div class="row">
      <!-- Phone Dialer -->
      <div class="col-12 col-lg-4">
        <div class="container" style="background-color: #E0F4F9;">
          <div class="row">
            <label *ngIf="isCountryCodeAvailable" style="color:#4297BF; text-align: left;padding-left: 4%;margin-top: 5%; font-weight: bold;">Country + {{paramPhoneCountryCode}}</label>
          </div>
          <div class="row">
            <div class="output-phone-number">
              <input class="output-phone-number-input" type="text" placeholder="(000)-000-0000" mask="(000) 000-0000"
                maxlength=10 [(ngModel)]="currentValue" />
            </div>
          </div>
          <div class="row">
            <div class="digit" id="one" (click)="onPressDigit(1)" (keydown)="onPressDigit(1)">1</div>
            <div class="digit" id="two" (click)="onPressDigit(2)" (keydown)="onPressDigit(2)">
              2
            </div>
            <div class="digit" id="three" (click)="onPressDigit(3)" (keydown)="onPressDigit(3)">
              3
            </div>
          </div>
          <div class="row">
            <div class="digit" id="four" (click)="onPressDigit(4)" (keydown)="onPressDigit(4)">
              4
            </div>
            <div class="digit" id="five" (click)="onPressDigit(5)" (keydown)="onPressDigit(5)">
              5
            </div>
            <div class="digit" (click)="onPressDigit(6)" (keydown)="onPressDigit(6)">
              6
            </div>
          </div>
          <div class="row">
            <div class="digit" (click)="onPressDigit(7)" (keydown)="onPressDigit(7)">
              7
            </div>
            <div class="digit" (click)="onPressDigit(8)" (keydown)="onPressDigit(8)">
              8
            </div>
            <div class="digit" (click)="onPressDigit(9)" (keydown)="onPressDigit(9)">
              9
            </div>
          </div>
          <div class="row">
            <div class="digit" style="color:lightblue" (click)="onPressAsterisk()">*</div>
            <div class="digit" (click)="onPressDigit(0)" (keydown)="onPressDigit(0)">0</div>
            <div class="digit" style="color:lightblue" (click)="onPressNumeral()">#</div>
          </div>
          <!-- Validation Message -->
          <div class="row" style="margin-top:11%;">
            <label style="color:red; text-align: left;padding-left: 7%;">{{validationMessage}}</label>
            <label style="color:red; text-align: left;padding-left: 7%;" *ngIf="isPhoneRequired">Phone number is
              required.</label>
            <label style="color:red; text-align: left;padding-left: 7%;" *ngIf="isInvalidPhone">Please enter valid
              Phone number.</label>
          </div>
          <!-- Dial/EndCall & Clear Button -->
          <div class="botrow">
            <div kendoTooltip class="grid-tooltip" position="bottom">
              <div class="call" title="Dial Now" (click)="onCallDial()"
                *ngIf="dialerAcsServiceAvailable && !dialerCallInProgress">
                <i class="fa fa-phone" aria-hidden="true"></i>Call
              </div>
            </div>
            <div kendoTooltip class="grid-tooltip" position="bottom">
              <div class="callEnd" title="End Call" (click)="onCallEnd()" *ngIf="dialerCallInProgress">
                <i class="fa fa-phone" aria-hidden="true"></i>End Call
              </div>
            </div>
            <div kendoTooltip class="grid-tooltip" position="bottom">
              <div class="clearCall" title="Clear Number" (click)="onResetDialer()">
                <i class="fa fa fa-long-arrow-left" aria-hidden="true"></i>Clear
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-8">
        <!-- Conversation -->
        <div class="common-primary-box">
          <div class="primary-header">
            <div class="box-title text-center">
              <h3>Conversation</h3>
            </div>
          </div>
          <div id="recordingDiv" style="height:350px; overflow-y: auto; text-align: left;"
            [innerHTML]="_voiceService.voiceText"></div>
          <textarea class="form-control call-log-textarea" rows="15" placeholder="Ongoing Conversation..."
            style="height: 70%; display: none;" maxlength="5000"></textarea>
        </div>

        <!-- RECORDING FILE -->
        <div class="col-lg-12 col-md-12">
          <div class="common-primary-box">
            <div class="primary-header">
              <div class="box-title text-center">
                <h3>Call Recording</h3>
              </div>
            </div>
            <div *ngIf="isRecording && !blobUrl"> {{recordedTime}} </div>
            <div style="height: 50px;">
              <audio *ngIf="!isRecording && blobUrl" controls>
                <source [src]="blobUrl" type="audio/webm">
              </audio>
            </div>
            <p>{{transcribedText}}</p>
            <textarea class="form-control call-log-textarea" rows="5" placeholder="Note" maxlength="450"
              style="display: none;"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Bottom Button -->
  <kendo-dialog-actions class="d-block text-end">
    <button kendoButton (click)="closePhoneDialerPopup()" class="btn btn-cancel btn-md">Close</button>
  </kendo-dialog-actions>
</kendo-dialog>